import { render } from "./AddDiskOffering.vue?vue&type=template&id=7d563424&scoped=true"
import script from "./AddDiskOffering.vue?vue&type=script&lang=js"
export * from "./AddDiskOffering.vue?vue&type=script&lang=js"

import "./AddDiskOffering.vue?vue&type=style&index=0&id=7d563424&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d563424"]])

export default __exports__